export default __webpack_public_path__ + "static/cta-man-649169624380e96a5a8d8ff63bfdfde2.jpg";